var _ellipse, _ellipse2, _g, _path, _path2, _path3, _path4, _ellipse3, _g2, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupComplete2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 177,
    viewBox: "0 0 250 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 88.0952,
    rx: 112.069,
    ry: 66.2066,
    fill: "#E5E7F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1878_22334",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 21,
    width: 226,
    height: 134
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 88.0952,
    rx: 112.069,
    ry: 66.2066,
    fill: "#E5E7F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1878_22334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2501 138.986L27.2563 138.982C24.4396 132.214 27.1233 124.407 33.5119 120.78L65.7397 101.679C72.7911 97.6768 81.7512 100.186 85.67 107.27L85.7731 107.462C89.6539 114.463 87.1258 123.278 80.1259 127.182L47.7888 146.094C40.1885 150.33 30.5904 147.012 27.2501 138.986Z",
    fill: "#FFEBD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.8809 251.721C-63.7376 245.834 -61.3952 240.727 -60.1916 239.062L-22.2855 187.331C-21.7449 186.58 -21.0541 185.944 -20.2529 185.481L62.9534 139.844C64.4951 138.946 66.0923 136.682 64.7752 134.614C61.8145 129.967 55.1637 116.876 52.1875 111.597C50.9655 109.429 48.6968 109.785 46.9697 110.804L-42.2183 160.418C-42.9208 160.828 -43.5362 161.372 -44.0427 162.009L-89.1373 217.873C-89.7159 218.612 -90.4511 219.216 -91.2862 219.644L-61.8809 251.721Z",
    fill: "#9B9BCC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.928 31.496C123.425 29.6803 127.59 29.697 131.072 31.5405L181.605 58.2931H68.3186L119.928 31.496Z",
    fill: "#9B9BCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3184 58.293H181.605V111.185C181.605 117.813 176.232 123.185 169.605 123.185H80.3183C73.6909 123.185 68.3184 117.813 68.3184 111.185V58.293Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.526 96.3123L99.9977 110.759H105.122L105.455 108.895H102.816L105.714 90.1892H104.175L92.2733 106.952L94.6987 91.6981H93.222L80.6819 108.834H78.5826L78.2173 110.759H82.0374L91.4141 97.9029L88.7901 113.286L90.3551 113.073L102.526 96.3123Z",
    fill: "#6C6B98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.546 89.0894L181.605 58.293H68.3184L123.546 89.0894Z",
    fill: "#9B9BCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1878_22334",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 21,
    width: 226,
    height: 134
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 88.0952,
    rx: 112.069,
    ry: 66.2066,
    fill: "#E5E7F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1878_22334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.225 98.6686L196.218 98.6645C198.907 91.8449 196.078 84.0898 189.622 80.5823L157.042 62.09C149.917 58.2207 141.005 60.8975 137.22 68.0534L137.12 68.2481C133.372 75.3202 136.065 84.086 143.137 87.8582L175.823 106.16C183.501 110.253 193.035 106.755 196.225 98.6686Z",
    fill: "#FFEBD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.455 209.711C289.201 203.791 286.763 198.728 285.529 197.086L246.659 146.075C246.104 145.335 245.401 144.712 244.592 144.264L160.544 100.196C158.985 99.327 157.346 97.0933 158.624 95.0015C161.497 90.2995 167.901 77.0857 170.778 71.7516C171.959 69.5613 174.234 69.8746 175.98 70.8617L266.083 118.793C266.793 119.19 267.418 119.722 267.937 120.349L314.072 175.357C314.664 176.086 315.41 176.676 316.253 177.088L287.455 209.711Z",
    fill: "#9B9BCC"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.557 78.9027C152.708 85.5701 144.182 87.8545 137.515 84.0051C132.611 81.174 130.079 75.8136 130.613 70.5232C130.741 69.2585 129.689 68.0586 128.434 68.2638L124.698 68.8748C123.895 69.0063 123.11 68.5531 122.822 67.7914L120.892 62.6885C120.604 61.9268 119.819 61.4736 119.016 61.6051L113.779 62.4617C112.911 62.6036 112.077 62.0651 111.85 61.216L109.504 52.4629C109.26 51.5501 109.801 50.6119 110.714 50.3674L114.724 49.2928C115.163 49.1754 115.63 49.2369 116.023 49.4638L134.905 60.3657C135.509 60.7142 136.259 60.653 136.842 60.2714C141.103 57.483 146.743 57.14 151.455 59.8604C158.122 63.7098 160.407 72.2353 156.557 78.9027ZM147.27 77.5646C149.214 78.6873 151.701 78.021 152.824 76.0764C153.946 74.1317 153.28 71.6451 151.336 70.5224C149.391 69.3996 146.904 70.0659 145.782 72.0106C144.659 73.9552 145.325 76.4418 147.27 77.5646Z",
    fill: "#6C6B98"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupComplete2);
export default __webpack_public_path__ + "static/media/signup-complete2.d7ce69e708edb1238e5895b4e9f9d147.svg";
export { ForwardRef as ReactComponent };